import { MagicConfigMixin, getFeatureEnabled } from '@gig/magic-common';
import { Mixins, Emit, Component } from 'vue-property-decorator';
import { NotificationStyle, NotificationDelay } from '../../services/notifications/notifications.constants.js';
import '../../services/notifications/notification.js';
import { notificationService } from '../../services/notifications/notifications.service.js';
import '../../services/live-chat/live-chat.service.js';
import cookies from 'js-cookie';
import './notification/index.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const COOKIE_POLICY_ACCEPTED = "cookie-policy-accepted";
let CookiePopupComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.topNavigationEnabled = false;
  }
  get notificationStyle() {
    return this.topNavigationEnabled ? NotificationStyle.TOP_NAV_COOKIE : NotificationStyle.MESSAGE;
  }
  created() {
    return __async(this, null, function* () {
      this.topNavigationEnabled = yield getFeatureEnabled("top-navigation");
      if (!cookies.get(COOKIE_POLICY_ACCEPTED)) {
        const cookiePopup = document.createElement("magic-cookie-popup-notification");
        cookiePopup.addEventListener("close", () => {
          notificationService.close(notification);
        });
        const notification = notificationService.show(cookiePopup, {
          dismissible: false,
          style: this.notificationStyle,
          uniqueID: "cookie-popup-text",
          closeDelay: NotificationDelay.PERMANENT,
          onClose: () => {
            this.onAccepted();
          }
        });
      }
    });
  }
  render() {
    return null;
  }
  onAccepted() {
    return;
  }
};
__decorateClass([
  Emit("accepted")
], CookiePopupComponent.prototype, "onAccepted", 1);
CookiePopupComponent = __decorateClass([
  Component({
    name: "cookie-popup"
  })
], CookiePopupComponent);

export default CookiePopupComponent;
